/**
 * LAUNCH — Datas de lançamento centralizadas
 *
 * Todas as datas de lançamento do site concentradas aqui.
 * Usar: import { LAUNCH_DATE } from '../config/launch'
 *
 * Última atualização: 2026-08-26
 */

/** Data de lançamento oficial do site */
export const LAUNCH_DATE = '2026-11-15'

/** E-mails de administradores que sempre têm acesso completo */
export const ADMIN_EMAILS = ['isaiasgamedev@gmail.com', 'gramikgames@gmail.com']
